import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'sonner';

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const handleStorageUpdate = () => {
      const updatedUser = localStorage.getItem('user');
      if (updatedUser) {
        const event = new CustomEvent('userLogin', { detail: JSON.parse(updatedUser) });
        window.dispatchEvent(event);
      }
    };

    window.addEventListener('storage', handleStorageUpdate);
    return () => window.removeEventListener('storage', handleStorageUpdate);
  }, []);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    if (username.length > 0 && password.length > 0) {
      const mockUserData = {
        fullName: username,
        email: `${username.toLowerCase().replace(/\s+/g, '.')}` + '@example.com',
        profilePhoto: '/placeholder.svg',
        isRegistered: true,
        isSubscribed: true
      };

      localStorage.setItem('user', JSON.stringify(mockUserData));
      toast.success('Login realizado com sucesso!');
      window.dispatchEvent(new Event('storage'));
      navigate('/home');
    } else {
      toast.error('Preencha todos os campos antes de entrar.');
    }
  };

  return (
    <div className="login-container h-screen w-full flex justify-center items-center relative">
      {/* Vídeo de fundo */}
      <div className="video-container absolute top-0 left-0 w-full h-full z-[-1] overflow-hidden">
        <video
          autoPlay
          muted
          loop
          id="bgVideo"
          className="min-w-full min-h-full object-cover opacity-50"
        >
          <source src="/videos/intro.mp4" type="video/mp4" />
        </video>
      </div>

      {/* Logo */}
      <nav className="navbar absolute top-5 left-5 z-[2]">
        <img
          src="/logo.png"
          alt="RusticoPlay Logo"
          className="h-[80px] w-auto max-w-[200px]"
        />
      </nav>

      {/* Caixa de Login */}
      <div className="login-box bg-[rgba(0,0,0,0.3)] p-10 rounded-lg w-full max-w-[400px] text-center z-[1] border border-rustico-brown">
        <h2 className="mb-5 text-[2rem] font-bold text-white">Entrar</h2>
        <form id="loginForm" onSubmit={handleSubmit}>
          <div className="input-group relative mb-6">
            <input
              type="text"
              placeholder="Nome de usuário"
              id="username"
              required
              className="w-full p-[12px] bg-[#1c1c1c] text-white text-base outline-none border-b-2 border-rustico-brown rounded-md placeholder:text-white/60"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
            />
          </div>
          <div className="input-group relative mb-6">
            <input
              type="password"
              placeholder="Senha"
              id="password"
              required
              className="w-full p-[12px] bg-[#1c1c1c] text-white text-base outline-none border-b-2 border-rustico-brown rounded-md placeholder:text-white/60"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>

          {/* Botão com transparência */}
          <button
            type="submit"
            className="flex items-center justify-center w-full py-[10px] px-[20px] bg-white/20 text-white text-base font-bold rounded hover:bg-white/30 transition-colors duration-300"
          >
            Entrar
          </button>
        </form>

        <p className="signup-link mt-5 text-[0.9rem] text-white/80">
          Novo por aqui?{' '}
          <Link
            to="/signup"
            className="text-[#ff003c] no-underline font-bold hover:underline"
          >
            Assine agora
          </Link>.
        </p>
      </div>
    </div>
  );
};

export default Login;
